export const INSERT_SEMESTER = "INSERT_SEMESTER";

export const DELETE_SEMESTER = "DELETE_SEMESTER";

export const EDIT_SEMESTER_INFO = "EDIT_SEMESTER_INFO";